import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    allAssessments: [],
    questions: [],
    loading: false,
    error: null,
};

const assessmentSlice = createSlice({
    name: 'assessment',
    initialState,
    reducers: {
        setAllAssessments: (state, action) => {
            state.allAssessments = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item, no: index + 1 })) : [];
        },
        setQuestions: (state, action) => {
            state.questions = action.payload;
        },
    },
    extraReducers: (builder) => {
    },
});

export const { setAllAssessments, setQuestions } = assessmentSlice.actions;

export default assessmentSlice.reducer;